<template>
  <div
    style="height:100vh;display:flex;flex-direction: row;padding:0;align-items:center;flex-grow:1;"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "HiSubPage"
};
</script>

<style scoped></style>
